import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid2';
import { Link } from "react-router-dom";
import Nav from './Nav'
import '../styles/Header.css';

function Header(props) {

    return (
        <Box 
            component="header" 
            sx={{ mb: 3, p: 2, width: '100%' }} 
            className="header"
        >
            <Grid 
                container 
                alignItems="center" 
                justifyContent="space-between" // Pousse les deux blocs principaux aux extrémités
                px={{ xs: 2, md: 5 }}
            >
                {/* BLOC GAUCHE : Logo + Texte */}
                <Grid sx={{ display: 'flex', alignItems: 'center', gap: 3 }}>
                    <Link to="/home" style={{ display: 'flex' }}>
                        <img 
                            src="pictures/small_esorex.jpg" 
                            alt="logo" 
                            style={{ height: '60px', width: 'auto' }} 
                        />
                    </Link>
                    
                    <div className="large-text" style={{ fontWeight: '500' }}>
                        ESOREX : European Platform for Occupational Radiation Exposure
                    </div>
                </Grid>

                {/* BLOC DROITE : Nav uniquement */}
                <Grid>
                    <Nav props={props} />
                </Grid>
            </Grid>
        </Box>
    );
}
export default Header